import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ToolStatusSelectorViewModel extends SelectorBaseViewModel<ToolStatus> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<ToolStatus[]> {
        let result = await ServerConnection.callServer('/Complex/ToolStatusServices/ListAllToolStatuses', {});
        return result.ToolStatuses.map(x => {
            let t = new ToolStatus(this);
            t.id = x.ToolStatusListId;
            t.title = `${x.StatusName} (${x.StatusCode})`;
            return t;
        });
    }
}

export class ToolStatus extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}